import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractTuiControl } from '@taiga-ui/legacy';
import { TUI_EDITOR_DEFAULT_TOOLS } from '@taiga-ui/editor';
import { TuiEditorToolType } from '@taiga-ui/editor';
import { isEqual } from 'lodash-es';

@Component({
  selector: 'app-editor-field',
  templateUrl: './editor-field.component.html',
  styleUrls: ['./editor-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditorFieldComponent extends AbstractTuiControl<string> implements OnChanges {
  @Input() excludeTools?: TuiEditorToolType[];
  @Input() includeTools?: TuiEditorToolType[];
  @Input() placeholder: string = '';

  tools: TuiEditorToolType[] = Array.from(TUI_EDITOR_DEFAULT_TOOLS);

  get focused(): boolean {
    return false;
  }

  protected getFallbackValue(): string {
    return '';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.includeTools || changes.excludeTools) {
      if (this.includeTools?.length) {
        this.tools = this.includeTools;
      }

      if (this.excludeTools?.length) {
        this.tools = this.tools.filter(tool => !this.excludeTools?.find(excludeTool => isEqual(excludeTool, tool)));
      }
    }
  }
}
